<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-car-ext-accept-list></dtg-manage-car-ext-accept-list>
    </div>
</div>